import React from 'react';
import { TooltipTrigger } from '@spark';
import { CONTACT_US_LINK_LABEL } from '../constants';
import '../customer-intents.css';

/**
 * Tooltip body for a SaaS-gated control (Figma 9035-9521): "To enable …
 * Contact us" where the trailing "Contact us" is an underlined, keyboard
 * focusable link that opens the customer-intents modal with `intent`
 * (`{features, autonomyLevels}` — the gated option the tooltip belongs to)
 * pre-checked. Without `onContactUs` the copy is plain text.
 */
export function ContactUsTooltipContent({ text, onContactUs, intent }) {
    if (!onContactUs || !text.endsWith(CONTACT_US_LINK_LABEL)) {
        return <p className="spark-tooltip-text">{text}</p>;
    }
    return (
        <p className="spark-tooltip-text customer-intent-tooltip">
            {text.slice(0, text.length - CONTACT_US_LINK_LABEL.length)}
            <button
                type="button"
                className="customer-intent-tooltip__link"
                // Keep focus (and the dropdown/tooltip) where it is; only the click matters.
                onMouseDown={(event) => event.preventDefault()}
                onClick={(event) => {
                    event.stopPropagation();
                    onContactUs(intent);
                }}
            >
                {CONTACT_US_LINK_LABEL}
            </button>
        </p>
    );
}

/**
 * Wraps `children` in a Spark tooltip carrying `ContactUsTooltipContent`.
 * Interactive whenever there is a link to click, so the bubble stays open
 * while the pointer travels from the control into it.
 */
export default function ContactUsTooltip({ text, onContactUs, intent, placement = 'top', className, children }) {
    return (
        <TooltipTrigger
            content={<ContactUsTooltipContent text={text} onContactUs={onContactUs} intent={intent} />}
            interactive={Boolean(onContactUs)}
            placement={placement}
            className={className}
        >
            {children}
        </TooltipTrigger>
    );
}
